import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UrlConstantsService } from './url-constants.service';

@Injectable()
export class HealthCheckService {
  constructor(
    private _http: HttpClient,
    private urls: UrlConstantsService
  ) { }

  public getApiHeathStatus() {
    return this._http.get<any>(this.urls.HEALTH_STATUS);
  }
}
